import { laneOccupationForm, ROAD_ORGAN } from "modules/ebiForms/definitions/sharedRoads";
import { EEbiFormOffice } from "modules/ebiForms/typings";

/**
 * D1. Wniosek o wydanie zezwolenia na zajęcie pasa drogowego drogi gminnej — zarząd dróg (jednostka organizacyjna gminy)
 * — art. 40 ust. 1–3, 8 i 11 ustawy o drogach publicznych, § 1 rozporządzenia RM z 1.06.2004 r. (t.j. Dz.U. 2016 poz. 1264).
 * Ta sama procedura co B5, inny organ i część katalogu (builder: definitions/sharedRoads.ts). Brak wzoru ogólnopolskiego;
 * pola zweryfikowane z wnioskiem ZDMK Kraków ZDMK-24 (https://kontakt.krakow.pl/c/document_library/get_file?uuid=e70405b9-d5c8-e09f-b857-692e6c46ffa9&groupId=536063
 * — pobrany 2026-10-22: tak): elementy pasa z długością, szerokością i powierzchnią, wykonawca i kierownik robót, okres,
 * projekt organizacji ruchu, harmonogram przy etapowaniu. Obiekt handlowy z katalogu = „inne urządzenie obce” (art. 40
 * ust. 2 pkt 3); załączniki dla ogródków i stoisk (opinie plastyka/konserwatora) — do potwierdzenia z zarządem dróg.
 */
const D1 = laneOccupationForm({
  code: "D1",
  title: "Wniosek do zarządu dróg o wydanie zezwolenia na zajęcie pasa drogowego drogi gminnej",
  description: "Zezwolenie zarządu dróg na zajęcie pasa drogi gminnej: roboty, urządzenia obce, obiekty handlowe i reklamy, zajęcie na prawach wyłączności.",
  organ: ROAD_ORGAN.municipalUnit,
  office: EEbiFormOffice.MunicipalUnit,
  road: "gminna",
});

export default D1;
